import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'em-tempo-real/:id/:name',
    loadComponent: () => import('./modules/news-details/news-details.component').then(m => m.NewsDetailsComponent),
  },
  {
    path: 'insights-btg/:id/:name',
    loadComponent: () => import('./modules/news-details/news-details.component').then(m => m.NewsDetailsComponent),
  }
];
